import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  hideZerosFromPriceContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  occupancyContainer: {
    position: 'relative',
    // bottom: 24,
    left: 0,
    display: 'flex',
    gap: 20
  },
  refreshButton: {
    marginBottom: 10
  },
  currencyContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 5
  },
  menuItemRight: {
    direction: 'ltr'
  }
}))

export default useStyles
